/* ADG Header — desktop mega/dropdown + Heather's three-level mobile drawer. No deps. */
(function () {
  'use strict';
  var header = document.querySelector('[data-adg-header]');
  if (!header) return;

  var scrim = header.querySelector('[data-adg-scrim]');
  var items = Array.prototype.slice.call(header.querySelectorAll('[data-adg-item]'))
    .filter(function (it) { return it.querySelector('[data-adg-trigger]') && it.querySelector('[data-adg-panel]'); });
  var openItem = null;
  var hoverTimer = null;
  function isDesktop() { return window.matchMedia('(min-width: 990px)').matches; }

  function open(item) {
    if (openItem && openItem !== item) close(openItem, true);
    item.classList.add('is-open');
    var t = item.querySelector('[data-adg-trigger]');
    if (t) t.setAttribute('aria-expanded', 'true');
    openItem = item;
    if (scrim) scrim.hidden = false;
  }
  function close(item, keepScrim) {
    if (!item) return;
    item.classList.remove('is-open');
    var t = item.querySelector('[data-adg-trigger]');
    if (t) t.setAttribute('aria-expanded', 'false');
    if (item === openItem) openItem = null;
    if (!keepScrim && scrim) scrim.hidden = true;
  }
  function closeAll() { if (openItem) close(openItem); }

  items.forEach(function (item) {
    var trig = item.querySelector('[data-adg-trigger]');

    item.addEventListener('mouseenter', function () {
      if (!isDesktop()) return;
      clearTimeout(hoverTimer);
      open(item);
    });
    item.addEventListener('mouseleave', function () {
      if (!isDesktop()) return;
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { close(item); }, 140);
    });
    trig.addEventListener('click', function (e) {
      var href = trig.getAttribute('href');
      // On desktop the panel already opens on hover, so a click on a real
      // parent link should navigate (e.g. Shop Art → all art). Placeholder
      // ("#") triggers still just toggle the dropdown.
      if (isDesktop() && href && href !== '#') return;
      e.preventDefault();
      if (openItem === item) close(item); else open(item);
    });
  });

  if (scrim) scrim.addEventListener('click', closeAll);
  document.addEventListener('click', function (e) {
    if (openItem && !openItem.contains(e.target)) closeAll();
  });
  window.addEventListener('resize', function () { if (!isDesktop()) closeAll(); });

  /* ------------------------------------------------------------------
   * Mobile drawer — a stack of panels, one visible at a time.
   *
   * Heather drew three levels (docs/figma/pages/mobile-wireframes:
   * parent-nav → shop-art-menu → art-category-menu). Every panel is already
   * in the DOM, so drilling is a class change: no fetch, no re-render, no
   * flash. `stack` is the breadcrumb from root to whatever is on screen;
   * panels behind it get .is-past so they slide out to the left rather than
   * the right, which is what makes back feel like back.
   * ------------------------------------------------------------------ */
  var burger = header.querySelector('[data-adg-burger]');
  var drawer = header.querySelector('[data-adg-drawer]');
  var panels = Array.prototype.slice.call(header.querySelectorAll('[data-adg-dpanel]'));
  var stack = ['root'];

  function panelById(id) {
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].getAttribute('data-adg-dpanel') === id) return panels[i];
    }
    return null;
  }

  function paint(moveFocus) {
    var current = stack[stack.length - 1];
    panels.forEach(function (p) {
      var id = p.getAttribute('data-adg-dpanel');
      var inStack = stack.indexOf(id) !== -1;
      p.classList.toggle('is-active', id === current);
      p.classList.toggle('is-past', inStack && id !== current);
    });
    var active = panelById(current);
    if (!active) return;
    // A panel drilled into, then left and re-entered, should start at the top.
    active.scrollTop = 0;
    if (moveFocus) {
      var target = active.querySelector('[data-adg-dback-btn], [data-adg-drawer-close]');
      if (target && target.focus) target.focus({ preventScroll: true });
    }
  }

  function drill(id) {
    if (!panelById(id)) return;
    stack.push(id);
    paint(true);
  }
  function back() {
    if (stack.length < 2) return;
    stack.pop();
    paint(true);
  }

  var closeTimer = null;

  function openDrawer() {
    if (!drawer) return;
    // Opening always starts at the top level. Doing the reset HERE rather than
    // on the close timer matters: reopen inside the 240ms slide-out and the
    // timer would either leave the old stack in place or, worse, fire later
    // and yank an already-open menu back to root.
    clearTimeout(closeTimer);
    stack = ['root'];
    paint(false);
    drawer.hidden = false;
    requestAnimationFrame(function () { header.classList.add('is-drawer-open'); });
    if (burger) burger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    header.classList.remove('is-drawer-open');
    if (burger) burger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    // The panels are deliberately left where they are while it slides away —
    // nothing should be seen snapping back behind the closing drawer.
    closeTimer = setTimeout(function () { if (drawer) drawer.hidden = true; }, 240);
  }

  if (burger) burger.addEventListener('click', openDrawer);

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var drillBtn = e.target.closest('[data-adg-drill]');
      if (drillBtn) { drill(drillBtn.getAttribute('data-adg-drill')); return; }
      if (e.target.closest('[data-adg-dback-btn]')) { back(); return; }
      if (e.target.closest('[data-adg-drawer-close]')) { closeDrawer(); }
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (header.classList.contains('is-drawer-open')) {
      // Escape backs out one level at a time, then closes — same as the
      // hardware back button people expect on a phone.
      if (stack.length > 1) back(); else closeDrawer();
      return;
    }
    closeAll();
  });

  window.addEventListener('resize', function () {
    if (isDesktop() && header.classList.contains('is-drawer-open')) closeDrawer();
  });

  paint(false);
})();
